module.exports = __webpack_public_path__ + "static/media/1890(2).3fae1dc1.jpg";